import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("PasswordResetInput")
export class PasswordResetInput {
    @JsonProperty("new_password")
    public newPassword: string = JsonPropertyEmpty;

    public constructor(args?: Partial<PasswordResetInput>) {
        Object.assign(this, args);
    }
}
